import Lottie from "react-lottie";
import { useParams } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert"; // Import
import React, { useEffect, useState } from "react";
import "react-confirm-alert/src/react-confirm-alert.css"; // Import css

import {
  url,
  token,
  is_superuser,
  is_franchise_admin,
  is_franchise_manager,
  is_franchise_staff,
  is_franchise_accountant,
  is_accountant_only,
  is_shop_admin,
  is_shop_manager,
} from "../../Functionalities/Config";
import {
  ManageDeliveryBoys,
  ManageOrders,
  ManageStatus,
  formatAMPM,
  showMessage,
} from "../../Functionalities/Functions";
import { foodAmountAfterItemDiscount } from "../../Functionalities/orderAmount";
import {
  canCompleteSelfPickup,
  changeOrderStatus,
  isContactAbroad,
  orderContactLines,
  orderNoteLines,
} from "./Logic";
import CancelOrderMenu from "./Component/CancelOrderMenu";
import EditOrderItems from "./Component/EditOrderItems";
import OrderEditHistory from "./Component/OrderEditHistory";
import OrderTag from "../../CoreComponents/OrderTag";
import { EDITED_COLOR, editedLabel } from "../../Functionalities/orderBadges";
import Footer from "../../CoreComponents/Footer";
import Header from "../../CoreComponents/Header";
import NavBar from "../../CoreComponents/NavBar";
import image from "../../Assets/images/logo.png";
import MainHeader from "../../CoreComponents/MainHeader";
import ModalComponent from "../../CoreComponents/ModalComponent";
import NoDataComponent from "../../CoreComponents/NoDataComponent";
import LoadingComponent from "../../CoreComponents/LoadingComponent";
import anim_indicator_red from "../../Assets/lottie/anim_indicator_red.json";
import ModalFilterComponent from "../PromoCode/Component/ModalFilterComponent";
import anim_indicator_green from "../../Assets/lottie/anim_indicator_green.json";
import FoodReadyControl from "../../CoreComponents/FoodReadyControl";
import { canAdminChangeFoodReady } from "../../Functionalities/foodReady";

function Body({ data, orderid, Status, foodReadyAt, onFoodReadyChange, editCount }) {
  const [search, setSearch] = useState("");
  const [statusDetails, setStatusDetails] = useState({
    id: "",
    orderid: orderid,
    desc: "",
    keyword: "change_status",
  });
  const [loading, setLoading] = useState(true);

  const [deldata, setdeldata] = useState([]);
  const [statusArray, setstatusArray] = useState([]);
  const [selectedSingleDeliveryBoy, setselectedSingleDeliveryBoy] = useState();

  useEffect(() => {
    getData();
  }, [search]);

  const operate = (key, id) => {
    changePrevState(id);

    if (key === "add") {
      setselectList([...selectList, id]);
    }
    if (key === "remove") {
      let remove = selectList.indexOf(id);
      setselectList(selectList.filter((_, i) => i !== remove));
    }
  };

  const getData = async () => {
    if (!is_shop_admin || !is_shop_manager) {
      let result = ManageDeliveryBoys(
        "",
        "get_in_order",
        "",
        `search_text=${search}&small_list=true`
      );
      let modifiedData = [];

      await result.then((result) => {
        if (result) {
          result.data.results.map((item) =>
            modifiedData.push({
              id: item.id,
              first_name: item.first_name,
              mobile: item.details && item.details.mobile,
              checked: false,
              status: item.status,
              ongoing_orders: item.ongoing_orders,
            })
          );
          setdeldata(modifiedData);
        }
      });
    }

    let statusRes = ManageStatus("", "get", "", "");
    statusRes.then((result) => {
      setLoading(false);
      setstatusArray(result.data);
    });
  };

  const [selectList, setselectList] = useState([]);

  const changePrevState = async (id) => {
    let newData = [];

    await deldata.map((item) => {
      if (item.id == id) {
        newData.push({
          id: item.id,
          first_name: item.first_name,
          mobile: item.mobile,
          checked: !item.checked,
        });
      } else {
        newData.push({
          id: item.id,
          first_name: item.first_name,
          mobile: item.mobile,

          checked: item.checked,
        });
      }
    });

    setdeldata(newData);
  };

  const assignDeliveryBoys = async (keyword) => {
    if (keyword == "all") {
      let new_list = [];
      await deldata.map((item, index) => {
        new_list.push(item.id);
      });
      setselectList(new_list);

      let new_data = [];
      deldata.map((item, index) => {
        new_data.push({
          id: item.id,
          first_name: item.first_name,
          mobile: item.mobile,
          checked: true,
        });
      });
      setdeldata(new_data);
    } else if (keyword == "submit") {
      if (!selectList.length) {
        showMessage(
          "Please select delivery boys",
          "danger",
          "Error!",
          "top",
          "top-right",
          0
        );
        return 0;
      }
      let result = ManageOrders("", "add", {
        keyword: "set_deliveryboy",
        order_id: orderid,
        deliveryboy_id: JSON.stringify(selectList),
      });
      result.then((result) => {
      });
    }
  };

  const assignSingleDelivery = () => {
    if (selectedSingleDeliveryBoy) {
      var axios = require("axios");
      var FormData = require("form-data");
      var data = new FormData();
      data.append("keyword", "set_deliveryboy");
      data.append("order_id", orderid);
      data.append("deliveryboy_id", selectedSingleDeliveryBoy);

      var config = {
        method: "post",
        url: url + "/delivery/assign/",
        headers: {
          Authorization: token,
        },
        data: data,
      };

      axios(config)
        .then(function (response) {
          if (response.data.Status === true) {
            window.location.reload();
            showMessage(
              "successfully updated delivery boy",
              "success",
              "Success!",
              "top",
              "top-right",
              0
            );
          } else {
            showMessage(
              response.data.Error,
              "danger",
              "Success!",
              "top",
              "top-right",
              0
            );
          }
        })
        .catch(function (error) {
          showMessage("Error", "danger", "Error!", "top", "top-right", 0);
        });
    } else {
      showMessage(
        "No delivery boy selected",
        "danger",
        "Error!",
        "top",
        "top-right",
        0
      );
    }
  };

  const changeStatus = (item, orderid, keyword, cancelation_type) => {
    setStatusDetails({
      ...statusDetails,
      id: item.id,
    });

    var stat = {
      ...statusDetails,
      id: item.id,
      orderid: orderid,
      desc: "",
      keyword: keyword,
      cancelation_type: cancelation_type,
    };

    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div
            className="custom-ui"
            style={{
              borderRadius: 2,
              border: "solid",
              padding: 10,
              margin: 10,
              borderWidth: 0.5,
            }}
          >
            <h3>
              Change status to{" "}
              {statusArray.find((item) => item.id == stat.id).name} ?
            </h3>
            <p>Are you sure?</p>
            <div class=" mb-4">
              <input
                class="form-control form-control-lg default-select "
                onChange={(e) => {
                  setStatusDetails({ ...statusDetails, desc: e.target.value });
                  stat = {
                    ...statusDetails,
                    id: item.id,
                    orderid: orderid,
                    desc: e.target.value,
                    keyword: keyword,
                    cancelation_type: cancelation_type,
                  };
                }}
                placeholder="Description "
              />
            </div>

            <button
              onClick={onClose}
              className="btn btn-primary"
              style={{ marginRight: 10 }}
            >
              Cancel
            </button>
            <button
              onClick={() => changeOrderStatus(stat)}
              className="btn btn-primary"
            >
              Change status
            </button>
          </div>
        );
      },
    });
  };

  useEffect(() => {
    if (Status) {
      if (data[0].order_type == "ONLINE") {
        if (
          data[0].actual_amount_collected + data[0].wallet_amount !==
          data[0].net_amount
        ) {
          if (data[0].status.id != 7) {
            showMessage(
              "amounts are mismatch",
              "danger",
              "Warning",
              "top",
              "top-right",
              0
            );
          }
        }
      }
    }

  }, [Status]);

  return (
    <div>
      <div className="content-body">
        <div className="container-fluid">
          {loading ? (
            <LoadingComponent />
          ) : (
            <>
              {data?.length > 0 ? (
                <div className="row">
                  <div className="col-xl-8 col-xxl-8">
                    <div className="row">
                      <div className="col-xl-12">
                        <div className="card">
                          <div className="card-body">
                            <h6
                              className="fs-20 font-w600  text-left"
                              style={{ marginVertical: 15 }}
                            >
                              Order Status : {data[0].status.name}
                            </h6>
                            <div className="row">
                              <div className="col-md-6">
                                {!data[0].delivery_boy && !data[0].self_pickup && (
                                  <>
                                    <div
                                      className="modal fade"
                                      id="sendMessageModal"
                                    >
                                      <div
                                        className="modal-dialog modal-dialog-centered"
                                        role="document"
                                      >
                                        <div className="modal-content">
                                          <div className="modal-header">
                                            <h5 className="modal-title">
                                              {" "}
                                              Delivery Boys{" "}
                                            </h5>
                                            <button
                                              type="button"
                                              className="close"
                                              data-dismiss="modal"
                                            >
                                              {" "}
                                              <span>×</span>{" "}
                                            </button>
                                          </div>
                                          <div className="modal-body">
                                            <form className="comment-form">
                                              <div className="row">
                                                <div className="table-responsive rounded card-table">
                                                  <table className="table items-table table-responsive-sm">
                                                    <tbody>
                                                      <tr>
                                                        <th className="my-0 text-black font-w500 fs-3">
                                                          Delivery boy
                                                        </th>
                                                        <th className="my-0 text-black font-w500 fs-3">
                                                          {" "}
                                                          Action
                                                        </th>
                                                      </tr>

                                                      {deldata.length > 0 &&
                                                        deldata.map(
                                                          (item, index) => {
                                                            return (
                                                              <tr className="alert alert-dismissible border-0">
                                                                <td>
                                                                  <div className="media">
                                                                    <div className="media-body">
                                                                      <small className="font-w500">
                                                                        <a
                                                                          className="text-primary"
                                                                          href="javascript:void(0);"
                                                                        >
                                                                          {" "}
                                                                          FDRDYBY{" "}
                                                                          {
                                                                            item.id
                                                                          }{" "}
                                                                          :{" "}
                                                                          {
                                                                            item.first_name
                                                                          }{" "}
                                                                        </a>
                                                                      </small>
                                                                      <br />
                                                                      <small className="font-w500">
                                                                        <a
                                                                          className="text-dark"
                                                                          href="javascript:void(0);"
                                                                        >
                                                                          {" "}
                                                                          {
                                                                            item.mobile
                                                                          }{" "}
                                                                        </a>
                                                                      </small>
                                                                    </div>
                                                                  </div>
                                                                </td>
                                                                <td>
                                                                  <h4 className="my-0 text-black font-w600">
                                                                    {item.checked ===
                                                                    false ? (
                                                                      <i
                                                                        onClick={() => {
                                                                          operate(
                                                                            "add",
                                                                            item.id
                                                                          );
                                                                        }}
                                                                        className="fa fa-plus-circle fa-2x"
                                                                        style={{
                                                                          cursor:
                                                                            "pointer",
                                                                          color:
                                                                            "green",
                                                                        }}
                                                                      />
                                                                    ) : (
                                                                      <i
                                                                        onClick={() => {
                                                                          operate(
                                                                            "remove",
                                                                            item.id
                                                                          );
                                                                        }}
                                                                        className="fa fa-minus-circle fa-2x"
                                                                        style={{
                                                                          cursor:
                                                                            "pointer",
                                                                          color:
                                                                            "green",
                                                                        }}
                                                                      />
                                                                    )}
                                                                  </h4>
                                                                </td>
                                                              </tr>
                                                            );
                                                          }
                                                        )}
                                                    </tbody>
                                                  </table>
                                                </div>
                                              </div>
                                            </form>
                                          </div>
                                          <div className="modal-footer">
                                            <button
                                              className="btn btn-primary"
                                              onClick={() => {
                                                assignDeliveryBoys("all");
                                              }}
                                            >
                                              Select all
                                            </button>
                                            <button
                                              data-toggle="modal"
                                              data-target="#sendMessageModal"
                                              className="btn btn-primary"
                                              onClick={() => {
                                                assignDeliveryBoys("submit");
                                              }}
                                            >
                                              submit
                                            </button>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                  </>
                                )}
                              </div>

                              {/* Status change start */}
                              {!is_superuser &&
                                !is_accountant_only &&
                                data[0].status.name != "delivered" && (
                                  <div className="col-md-12 d-flex justify-content-between">
                                    <div className="btn-group" role="group">
                                      {statusArray.length > 0
                                        ? statusArray.map((status, index) => {
                                            const statusButton = () => {
                                              return (
                                                <button
                                                  key={index}
                                                  type="button"
                                                  style={{
                                                    textTransform: "capitalize",
                                                  }}
                                                  class={`btn btn-primary btn-xs `}
                                                  onClick={(e) => {
                                                    e.preventDefault();
                                                    changeStatus(
                                                      status,
                                                      orderid,
                                                      "change_status",
                                                      ""
                                                    );
                                                  }}
                                                >
                                                  {status.name}
                                                </button>
                                              );
                                            };
                                            // removing unwanted statuses
                                            if (
                                              !(
                                                (status.id == 1) |
                                                (status.id == 4) |
                                                (status.id == 7) |
                                                (status.id == 8)
                                              )
                                            ) {
                                              if (
                                                data[0].status.id == 1 &&
                                                (status.id == 2) |
                                                  (status.id == 3) |
                                                  (status.id == 7)
                                              ) {
                                                // if status is pending
                                                return statusButton();
                                              }
                                              if (
                                                status.id == 6 &&
                                                canCompleteSelfPickup(data[0])
                                              ) {
                                                return statusButton();
                                              }
                                              if (
                                                data[0].status.id == 4 &&
                                                (status.id == 5) |
                                                  (status.id == 6)
                                              ) {
                                                // if status is outfor delviery
                                                return statusButton();
                                              }
                                              if (
                                                data[0].status.id == 5 &&
                                                status.id == 6
                                              ) {
                                                // if status is delivery
                                                return statusButton();
                                              }
                                              if (data[0].status.id == 6) {
                                                // if status is delivered
                                                // return statusButton()
                                              }
                                            } else if (status.id == 7) {
                                              if (
                                                !(
                                                  data[0].status.id == 7 ||
                                                  data[0].status.id == 3
                                                )
                                              ) {
                                                // if status is cancelled

                                                if (!is_superuser) {
                                                  return (
                                                    <CancelOrderMenu
                                                      order={data[0]}
                                                      onCancel={(type) =>
                                                        changeStatus(status, orderid, "cancel_order", type)
                                                      }
                                                    />
                                                  );
                                                }
                                              }
                                            }
                                          })
                                        : "no status"}
                                    </div>
                                  </div>
                                )}
                              {/* Status change end */}
                            </div>
                          </div>
                        </div>
                      </div>

                      <ModalComponent
                        heading={"Delivery Boys"}
                        primaryButton={(e) => {
                          e.preventDefault();
                          setselectedSingleDeliveryBoy();
                        }}
                        primaryButtonName={"Cancel"}
                        secondaryButton={(e) => {
                          e.preventDefault();
                          assignSingleDelivery();
                        }}
                        secondaryButtonName={"Submit"}
                        rightBottonButton={true}
                      >
                        <ModalFilterComponent
                          searchFunction={(data) => {
                            setSearch(data);
                          }}
                        />
                        <div className="table-responsive rounded card-table">
                          <table className="table items-table table-responsive-sm">
                            <tbody>
                              <tr>
                                <th className="my-0 text-black font-w500 fs-3">
                                  Delivery boy
                                </th>
                                <th className="my-0 text-black font-w500 fs-3">
                                  Select
                                </th>
                              </tr>

                              {deldata.length > 0 &&
                                deldata.map((item, index) => {
                                  return (
                                    <tr className="alert alert-dismissible border-0">
                                      <td>
                                        <div className="media">
                                          <div className="media-body">
                                            <small className="font-w500">
                                              <div
                                                style={{
                                                  display: "flex",
                                                  justifyContent: "left",
                                                  alignItems: "left",
                                                }}
                                              >
                                                <div>
                                                  <Lottie
                                                    isClickToPauseDisabled
                                                    options={{
                                                      loop: true,
                                                      autoplay: true,
                                                      animationData: item.status
                                                        ? anim_indicator_green
                                                        : anim_indicator_red,
                                                      rendererSettings: {
                                                        preserveAspectRatio:
                                                          "xMidYMid slice",
                                                      },
                                                    }}
                                                    height={30}
                                                    width={30}
                                                  ></Lottie>
                                                </div>
                                                <div className="mt-2">
                                                  <a
                                                    className="text-primary"
                                                    href="javascript:void(0);"
                                                  >
                                                    FDRDLBY{item.id} :{" "}
                                                    {item.first_name}{" "}
                                                  </a>
                                                </div>
                                              </div>
                                            </small>

                                            <small className="font-w500 ml-4">
                                              <a
                                                className="text-dark"
                                                href="javascript:void(0);"
                                              >
                                                {" "}
                                                {item.mobile}
                                              </a>
                                            </small>
                                            <br />
                                            <small className="font-w500 ml-4">
                                              <a
                                                className="text-dark"
                                                href="javascript:void(0);"
                                              >
                                                {" "}
                                                Ongoing orders:{" "}
                                                {item.ongoing_orders}
                                              </a>
                                            </small>
                                          </div>
                                        </div>
                                      </td>
                                      <td>
                                        <h4 className="my-0 text-black font-w600">
                                          {item.id ===
                                          selectedSingleDeliveryBoy ? (
                                            <i
                                              onClick={() => {
                                                setselectedSingleDeliveryBoy(
                                                  item.id
                                                );
                                              }}
                                              className="fa fa-check-square-o  fa-2x"
                                              style={{
                                                cursor: "pointer",
                                                color: "green",
                                              }}
                                            />
                                          ) : (
                                            <i
                                              onClick={() => {
                                                setselectedSingleDeliveryBoy(
                                                  item.id
                                                );
                                              }}
                                              className="fa fa-square-o fa-2x"
                                              style={{
                                                cursor: "pointer",
                                                color: "green",
                                              }}
                                            />
                                          )}
                                        </h4>
                                      </td>
                                    </tr>
                                  );
                                })}
                            </tbody>
                          </table>
                        </div>
                      </ModalComponent>

                      {/*  delivery boy start  */}
                      {data[0].status.id !== 1 &&
                        data[0].status.id !== 3 &&
                        data[0].status.id !== 6 &&
                        data[0].status.id !== 7 && (
                          <div className="col-xl-12">
                            <div className="card">
                              <div className="card-body p-0">
                                <div className="table-responsive order-list card-table">
                                  <div className="text-right">
                                    {/* A self-pickup order is collected by the customer; the backend
                                        refuses both a pool broadcast and a direct assignment, so the
                                        whole rider panel is hidden rather than offering a button that
                                        only returns an error. */}
                                    {!data[0].self_pickup && (
                                    <div
                                      className="col-md-12"
                                      style={{
                                        border: "solid 1px rgba(0,0,0,0.1)",
                                        borderRadius: "20px",
                                        padding: "20px",
                                      }}
                                    >
                                      <div className="row align-items-center">
                                        <div className="col-md-12">
                                          <h6
                                            className="fs-20 font-w600  text-left"
                                            style={{ marginVertical: 15 }}
                                          >
                                            {" "}
                                            Delivery Boy
                                          </h6>

                                          <div className="col-md-12">
                                            <div class="form-group row mt-2">
                                              {(is_franchise_admin ||
                                                is_franchise_manager ||
                                                is_franchise_staff) && (
                                                <div>
                                                  <button
                                                    style={{ marginRight: 15 }}
                                                    class="btn btn-primary"
                                                    type="submit"
                                                    data-toggle="modal"
                                                    data-target="#sendModal"
                                                    id="timepicker"
                                                  >
                                                    {data[0].delivery_boy !==
                                                    null
                                                      ? "Re-Assign a Delivery Boy"
                                                      : "Assign a Delivery Boy"}
                                                  </button>
                                                </div>
                                              )}

                                              {data[0].delivery_boy ? (
                                                <>
                                                  <a
                                                    href={
                                                      (is_franchise_admin ||
                                                        is_franchise_manager ||
                                                        is_franchise_staff ||
                                                        is_franchise_accountant) &&
                                                      `/deliboy/` +
                                                        data[0].delivery_boy.id
                                                    }
                                                  >
                                                    <div>
                                                      <button class="btn btn-primary">
                                                        {
                                                          data[0].delivery_boy
                                                            .first_name
                                                        }{" "}
                                                        {""}
                                                        {
                                                          data[0].delivery_boy
                                                            .details.mobile
                                                        }
                                                      </button>
                                                    </div>
                                                  </a>
                                                </>
                                              ) : (
                                                <h6
                                                  className="fs-12 font-w600"
                                                  style={{
                                                    display: "flex",
                                                    alignItems: "center",
                                                    justifyContent: "center",
                                                  }}
                                                >
                                                  {(is_superuser ||
                                                    is_franchise_admin ||
                                                    is_franchise_manager ||
                                                    is_franchise_staff) &&
                                                    "No Delivery Boy Selected"}
                                                </h6>
                                              )}
                                            </div>
                                          </div>
                                        </div>
                                      </div>
                                    </div>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        )}
                      {/* delivery boy end */}

                      {/* items start  */}
                      <div className="col-xl-12">
                        <div className="card">
                          <div className="card-body p-0">
                            <div className="table-responsive order-list card-table">
                              <table className="table items-table table-responsive-md">
                                <tbody>
                                  <tr>
                                    <th className="my-0 text-black font-w500 fs-20">
                                      {" "}
                                      Items
                                    </th>
                                    <th
                                      style={{ width: "10%" }}
                                      className="my-0 text-black font-w500 fs-20"
                                    >
                                      Qty{" "}
                                    </th>
                                    <th
                                      style={{ width: "10%" }}
                                      className="my-0 text-black font-w500 fs-20"
                                    >
                                      Price{" "}
                                    </th>
                                    <th className="my-0 text-black font-w500 fs-20 wspace-no d-md-none d-lg-table-cell">
                                      Total{" "}
                                    </th>
                                    <th className="text-right">
                                      {(is_superuser ||
                                        is_franchise_admin ||
                                        is_franchise_manager ||
                                        is_franchise_staff) &&
                                        // pending, approved, rider assigned, out for
                                        // delivery. Not delivered, cancelled or declined.
                                        [1, 2, 4, 5].includes(data[0].status.id) &&
                                        // Not on self-pickup: raising the total books an
                                        // amount for a delivery boy to collect, and a
                                        // self-pickup order never has one.
                                        !data[0].self_pickup && (
                                          <EditOrderItems orderid={orderid} />
                                        )}
                                    </th>
                                  </tr>

                                  {data[0].issued_items.length > 0
                                    ? data[0].issued_items.map(
                                        (item, index) => {
                                          return (
                                            <tr className="alert alert-dismissible border-0">
                                              <td>
                                                <div className="media">
                                                  <a
                                                    href={
                                                      `/productID/` +
                                                      item.item.id
                                                    }
                                                  >
                                                    {item.item.images[0] ? (
                                                      <img
                                                        className="mr-3 img-fluid rounded"
                                                        width={85}
                                                        src={
                                                          url +
                                                          item.item.images[0]
                                                            .image
                                                        }
                                                        alt="Foodoor"
                                                      />
                                                    ) : (
                                                      <img
                                                        className="mr-3 img-fluid rounded"
                                                        width={85}
                                                        src={image}
                                                        alt="Foodoor"
                                                      />
                                                    )}
                                                  </a>
                                                  <div className="media-body">
                                                    <small className="mt-0  font-w500">
                                                      <a
                                                        href={
                                                          `/productID/` +
                                                          item.item.id
                                                        }
                                                      >
                                                        {" "}
                                                        {item.item_varient.name}
                                                      </a>
                                                    </small>
                                                    <br></br>
                                                    <small className="mt-0  font-w500">
                                                      <a
                                                        href={
                                                          `/productID/` +
                                                          item.item.id
                                                        }
                                                      >
                                                        {" "}
                                                        {item.item.name}{" "}
                                                      </a>
                                                    </small>
                                                    <h5 className="mt-0 mb-2 mb-4">
                                                      <a
                                                        href={
                                                          `/restaurant/` +
                                                          item.item.branch.id
                                                        }
                                                      >
                                                        {(!is_superuser ||
                                                          is_franchise_admin ||
                                                          is_franchise_manager ||
                                                          is_franchise_staff) &&
                                                          item.item.branch.name}
                                                      </a>
                                                    </h5>
                                                  </div>
                                                </div>
                                              </td>
                                              <td>
                                                {" "}
                                                <h6 className="my-0 text-black font-w600">
                                                  {item.qty}
                                                </h6>{" "}
                                              </td>
                                              <td>
                                                {" "}
                                                <h6 className="my-0 text-black font-w600">
                                                  {" "}
                                                  ₹{" "}
                                                  {item.offer_rate
                                                    ? item.offer_rate
                                                    : item.rate}{" "}
                                                </h6>{" "}
                                              </td>
                                              <td className="d-md-none d-lg-table-cell">
                                                {" "}
                                                <h6 className="my-0 text-black font-w600">
                                                  ₹ {item.net_amt}{" "}
                                                </h6>{" "}
                                              </td>
                                            </tr>
                                          );
                                        }
                                      )
                                    : "No Records found :("}
                                </tbody>
                              </table>
                              <div
                                className="text-right "
                                style={{ marginRight: "20%" }}
                              ></div>
                            </div>
                          </div>
                        </div>
                      </div>
                      {/* items end  */}

                      {/* customer start  */}
                      {(is_superuser ||
                        is_franchise_admin ||
                        is_franchise_manager ||
                        is_franchise_staff) && (
                        <div className="col-xl-12">
                          <div className="card">
                            <div className="card-body p-0">
                              <div className="table-responsive order-list card-table">
                                <div className="text-right">
                                  <div
                                    className="col-md-12"
                                    style={{
                                      border: "solid 1px rgba(0,0,0,0.1)",
                                      borderRadius: "20px",
                                      padding: "20px",
                                    }}
                                  >
                                    <div className="row align-items-center">
                                      <div className="col-xl-12 col-xxl-12 col-lg-6 mb-3">
                                        <div className="d-flex">
                                          <span className="text-black font-w500">
                                            {" "}
                                            Customer :{" "}
                                          </span>
                                          <span className="text-black font-w500">
                                            {" "}
                                            {data[0].user.first_name}
                                          </span>
                                        </div>
                                      </div>

                                      <div className="col-xl-12 col-xxl-12 col-lg-6 mb-3">
                                        <div className="d-flex">
                                          <span className="text-black font-w500">
                                            {" "}
                                            Mobile :{" "}
                                          </span>
                                          <span className="text-black font-w500">
                                            {" "}
                                            {data[0].user.details
                                              ? data[0].user.details.mobile
                                              : "NA"}
                                          </span>
                                        </div>
                                      </div>
                                      {orderContactLines(data[0]).map((line) => (
                                        <div
                                          key={line.label}
                                          className="col-xl-12 col-xxl-12 col-lg-6 mb-3"
                                        >
                                          <div className="d-flex">
                                            <span className="text-black font-w500">
                                              {" "}
                                              {line.label} :{" "}
                                            </span>
                                            <a
                                              className="text-black font-w500"
                                              href={line.href}
                                              target="_blank"
                                              rel="noreferrer"
                                            >
                                              {" "}
                                              {line.value}
                                            </a>
                                          </div>
                                        </div>
                                      ))}
                                      {isContactAbroad(data[0]) && (
                                        <div className="col-xl-12 col-xxl-12 col-lg-6 mb-3">
                                          <span className="badge badge-danger">
                                            Customer abroad: online payment, reach them on WhatsApp
                                          </span>
                                        </div>
                                      )}
                                      <div className="col-xl-12 col-xxl-12 col-lg-6 mb-1">
                                        <div className="d-flex">
                                          <span className="text-black font-w500">
                                            {" "}
                                            Delivery address :{" "}
                                          </span>
                                          <b className="text-black font-w400">
                                            {data[0].address ? (
                                              <span>
                                                &nbsp;{" "}
                                                <b>
                                                  {" "}
                                                  {
                                                    data[0].address.land_mark
                                                  }{" "}
                                                </b>{" "}
                                                - {data[0].address.address1}
                                              </span>
                                            ) : (
                                              "NA"
                                            )}
                                          </b>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      {/* customer end */}
                    </div>
                  </div>

                  <div className="col-xl-4 col-xxl-4">
                    <div className="row">
                      <div className="col-xl-12 col-sm-6">
                        <div className="card">
                          <div className="card-body">
                            {(is_superuser ||
                              is_franchise_staff ||
                              is_franchise_manager ||
                              is_franchise_admin) && (
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  textAlign: "center",
                                }}
                              >
                                <h4 className="fs-20 font-w600  text-center">
                                  Order Details
                                </h4>

                                <a
                                  href={"/order_export?id=" + orderid}
                                  style={{
                                    borderRadius: 8,
                                    padding: 10,
                                    backgroundColor: "#3fb049",
                                    marginLeft: 10,
                                  }}
                                >
                                  {" "}
                                  <i
                                    class="fa fa-file"
                                    style={{ color: "white" }}
                                    aria-hidden="true"
                                  ></i>
                                </a>
                              </div>
                            )}
                            <span className="text-left">
                              <ul className="timeline">
                                <li>
                                  <h4 className="mb-2 ">
                                    Order{" "}
                                    {data[0].self_pickup && (
                                      <span
                                        className="badge badge-sm badge-info ml-2"
                                        style={{ fontSize: "10px" }}
                                      >
                                        SELF PICKUP
                                      </span>
                                    )}
                                  </h4>
                                  <p className="fs-15 mb-0 ">
                                    Order ID : FDR{data[0].id}
                                  </p>
                                  {editedLabel(editCount) && (
                                    <OrderTag color={EDITED_COLOR} title="Items were changed after the order was placed">
                                      {editedLabel(editCount)}
                                    </OrderTag>
                                  )}
                                  {(is_superuser ||
                                    is_franchise_staff ||
                                    is_franchise_manager ||
                                    is_franchise_admin) && (
                                    <p className="fs-15 mb-0 ">
                                      Order Pin : {data[0].order_pin}
                                    </p>
                                  )}
                                  <p className="fs-15 mb-0 ">
                                    Date :{" "}
                                    {new Date(data[0].date).toDateString()}{" "}
                                    {formatAMPM(new Date(data[0].date))}
                                  </p>
                                  {data[0].scheduled_slot && (
                                    <p className="fs-15 mb-0 ">
                                      Scheduled Delivery :{" "}
                                      <b>
                                        {new Date(
                                          data[0].scheduled_slot.scheduled_date
                                        ).toDateString()}{" "}
                                        {formatAMPM(
                                          new Date(
                                            `1970-01-01T${data[0].scheduled_slot.from_time}`
                                          )
                                        )}{" "}
                                        -{" "}
                                        {formatAMPM(
                                          new Date(
                                            `1970-01-01T${data[0].scheduled_slot.to_time}`
                                          )
                                        )}
                                        {data[0].scheduled_slot.label
                                          ? ` (${data[0].scheduled_slot.label})`
                                          : ""}
                                      </b>
                                    </p>
                                  )}
                                  <hr />
                                </li>
                                {(is_superuser ||
                                  is_franchise_staff ||
                                  is_franchise_manager ||
                                  is_franchise_admin) && (
                                  <>
                                    <li>
                                      <h4 className="mb-2">Order Amount </h4>
                                      <p className="fs-15 mb-0 ">
                                        Amount :{" "}
                                        <b>
                                          {" "}
                                          ₹{" "}
                                          {Number(data[0].item_discount) > 0 ? (
                                            <>
                                              {foodAmountAfterItemDiscount(data[0])}{" "}
                                              <span
                                                style={{
                                                  textDecoration:
                                                    "line-through",
                                                  marginLeft: 6,
                                                }}
                                              >{`(${data[0].amount})`}</span>{" "}
                                            </>
                                          ) : (
                                            data[0].amount
                                          )}
                                        </b>
                                      </p>
                                      {data[0].item_discount != 0 && (
                                        <p className="fs-15 mb-0 ">
                                          Item Discount :
                                          <b> ₹ {data[0].item_discount}</b>{" "}
                                        </p>
                                      )}
                                      {data[0].promo_discount != 0 && (
                                        <p className="fs-15 mb-0 ">
                                          Promocode Discount :
                                          <b>₹ {data[0].promo_discount}</b>{" "}
                                        </p>
                                      )}
                                      {data[0].wallet_amount != 0 && (
                                        <p className="fs-15 mb-0 ">
                                          Wallet amount :{" "}
                                          <b>
                                            ₹{" "}
                                            {JSON.stringify(
                                              data[0].wallet_amount
                                            )}
                                          </b>{" "}
                                        </p>
                                      )}
                                      <p className="fs-15 mb-0 ">
                                        Delivery charge :{" "}
                                        {Number(data[0].delivery_charge_data) > Number(data[0].delivery_charge) ? (
                                          <>
                                            <s className="text-muted">₹ {data[0].delivery_charge_data}</s>{" "}
                                            <b>₹ {data[0].delivery_charge}</b>{" "}
                                            <span className="badge badge-success">free delivery</span>
                                          </>
                                        ) : (
                                          <b>₹ {data[0].delivery_charge}</b>
                                        )}
                                      </p>
                                      {data[0].delivery_boy_tip > 0 && (
                                        <p className="fs-15 mb-0 ">
                                          Delivery Boy Tip :{" "}
                                          <b>₹ {data[0].delivery_boy_tip}</b>
                                        </p>
                                      )}
                                      {data[0].foodoor_cares > 0 && (
                                        <p className="fs-15 mb-0 ">
                                          Foodoor Cares :{" "}
                                          <b>₹ {data[0].foodoor_cares}</b>
                                        </p>
                                      )}
                                      <p className="fs-15 mb-0 ">
                                        Branch GST charge :{" "}
                                        <b>₹ {data[0].branch_gst_charge}</b>
                                      </p>
                                      {data[0].extra_belly_charges != 0 && (
                                        <p className="fs-15 mb-0 ">
                                          Surge :{" "}
                                          <b>
                                            ₹ {`${data[0].extra_belly_charges}`}
                                          </b>
                                        </p>
                                      )}
                                      {data[0].other_charges != 0 && (
                                        <p className="fs-15 mb-0 ">
                                          Restaurant charge :{" "}
                                          <b>₹ {`${data[0].other_charges}`}</b>
                                        </p>
                                      )}
                                      {/* Without this the charges above do not
                                          add up to Net Amount: the payable is
                                          rounded to a whole rupee and the
                                          difference lives here. Null on orders
                                          placed before rounding existed. */}
                                      {data[0].round_off !== null &&
                                        data[0].round_off !== undefined &&
                                        Number(data[0].round_off) !== 0 && (
                                          <p className="fs-15 mb-0 ">
                                            Round off :{" "}
                                            <b>
                                              {Number(data[0].round_off) > 0
                                                ? "+ ₹ "
                                                : "- ₹ "}
                                              {Math.abs(
                                                Number(data[0].round_off)
                                              ).toFixed(2)}
                                            </b>
                                          </p>
                                        )}
                                      <p className="fs-15 mb-0 ">
                                        Net Amount :{" "}
                                        <b>₹ {data[0].net_amount}</b>
                                      </p>
                                      <hr />
                                    </li>

                                    {data[0].payment && (
                                      <li>
                                        <h4 className="mb-2">Payment</h4>
                                        <p className="fs-15 mb-0 ">
                                          Payment Method :{" "}
                                          <b>{data[0].payment.status}</b>
                                        </p>
                                        {data[0].payment.status !== "COD" && (
                                          <p className="fs-15 mb-0 ">
                                            Transaction Amount :{" "}
                                            <b>₹ {data[0].payment.amount}</b>
                                          </p>
                                        )}
                                        {data[0].payment.status !== "COD" && (
                                          <p className="fs-15 mb-0 ">
                                            Transaction Id :{" "}
                                            <b>
                                              {data[0].payment.transaction_id}
                                            </b>
                                          </p>
                                        )}
                                        <hr />
                                      </li>
                                    )}
                                  </>
                                )}

                                {data[0].promo_discount ? (
                                  <a
                                    href={
                                      (!is_superuser ||
                                        is_franchise_admin ||
                                        is_franchise_manager ||
                                        is_franchise_staff) &&
                                      `/editpromo/${data[0].promocode.id}`
                                    }
                                  >
                                    <h4 className="mb-2">Promo Code </h4>
                                    <p className="fs-15 mb-0 ">
                                      Code : <b>{data[0].promocode.code}</b>
                                    </p>
                                    <p className="fs-15 mb-0 ">
                                      Promocode Discount :{" "}
                                      <b>{data[0].promo_discount}</b>
                                    </p>
                                    <hr />
                                  </a>
                                ) : (
                                  ""
                                )}
                              </ul>
                            </span>
                          </div>
                          <div className="card-body bg-light rounded-top">
                            <h3 className="fs-18 text-black font-w600">
                              Order notes
                            </h3>
                            {orderNoteLines(data[0]).length === 0 ? (
                              <p className="fs-14 text-muted">No notes</p>
                            ) : (
                              orderNoteLines(data[0]).map((line) => (
                                <p key={line.label} className="fs-14 mb-1">
                                  <b>{line.label}:</b> {line.text}
                                </p>
                              ))
                            )}
                          </div>
                          {!is_accountant_only && (foodReadyAt || canAdminChangeFoodReady(data[0])) && (
                            <div className="card-body bg-light pt-0">
                              <h3 className="fs-18 text-black font-w600">Food ready</h3>
                              <FoodReadyControl
                                order={data[0]}
                                foodReadyAt={foodReadyAt}
                                onChange={onFoodReadyChange}
                              />
                            </div>
                          )}
                          <a
                            className="text-black"
                            href={`/restaurant/${data[0].branch.id}`}
                          >
                            <div className="card-footer d-flex align-items-center gradient-bg">
                              <span className="p-3 mr-3 d-inline-block rounded-circle bg-white">
                                <svg
                                  xmlns="http://www.w3.org/2000/svg"
                                  width={28}
                                  height={28}
                                  viewBox="0 0 37.726 44.713"
                                >
                                  <path
                                    id="Icon_metro-spoon-fork"
                                    data-name="Icon metro-spoon-fork"
                                    d="M11.918,1.928c-4.63,0-8.384,4.379-8.384,9.781,0,4.625,2.752,8.5,6.45,9.519L8.6,43.851a2.6,2.6,0,0,0,2.623,2.789h1.4a2.6,2.6,0,0,0,2.623-2.789L13.852,21.228c3.7-1.019,6.45-4.894,6.45-9.519,0-5.4-3.753-9.781-8.384-9.781Zm28.178,0L37.768,15.9H36.021L34.857,1.928H33.692L32.528,15.9H30.781L28.453,1.928H27.288V20.092a1.4,1.4,0,0,0,1.4,1.4h3.639L30.953,43.851a2.6,2.6,0,0,0,2.623,2.789h1.4A2.6,2.6,0,0,0,37.6,43.851L36.225,21.49h3.639a1.4,1.4,0,0,0,1.4-1.4V1.928Z"
                                    transform="translate(-3.535 -1.928)"
                                    fill="#3fb049"
                                  />
                                </svg>
                              </span>
                              <span className="text-white font-w600">
                                {data[0].branch ? (
                                  <>
                                    {data[0].branch.name}
                                    <br />
                                    {data[0].branch.mobile}
                                    <br />
                                    {data[0].branch.place}{" "}
                                  </>
                                ) : (
                                  "No Restaurant details"
                                )}
                              </span>
                            </div>
                          </a>
                        </div>
                      </div>

                      <OrderEditHistory orderId={editCount > 0 ? data[0].id : null} />

                      <div className="col-xl-12 col-sm-6">
                        <div className="card">
                          <div className="card-header border-0 pb-0">
                            <h4 className="fs-20 font-w600">History</h4>
                          </div>
                          <div className="card-body pb-0">
                            <div className="widget-timeline-icon2">
                              <ul className="timeline">
                                {data[0].status_history.length > 0
                                  ? data[0].status_history.map(
                                      (item, index) => {
                                        return (
                                          <li>
                                            <div className="icon bg-primary las"></div>
                                            <a
                                              className="timeline-panel text-muted"
                                              href="javascript:void(0);"
                                            >
                                              <h4 className="mb-2 ">
                                                {item.status.name}
                                              </h4>
                                              <p className="fs-15 mb-0 ">
                                                {new Date(
                                                  item.date
                                                ).toDateString()}{" "}
                                                {formatAMPM(
                                                  new Date(item.date)
                                                )}
                                              </p>
                                              <p className="fs-15 mb-0 ">
                                                {item.description}
                                              </p>
                                            </a>
                                          </li>
                                        );
                                      }
                                    )
                                  : "NA"}
                              </ul>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <NoDataComponent data=" Order" />
              )}
            </>
          )}
        </div>
      </div>
    </div>
  );
}

function OrderID() {
  const { id } = useParams();
  const [data, setData] = useState({ id: "", name: "", data: [] });
  const [status, setstatus] = useState(false);
  const [foodReadyAt, setFoodReadyAt] = useState(null);
  const [editCount, setEditCount] = useState(0);

  useEffect(() => {
    getData();
    ManageOrders("", "get", "", "view=summary&id=" + id).then((result) => {
      const row = result?.data?.results?.[0];
      setFoodReadyAt(row?.food_ready_at || null);
      setEditCount(row?.edit_count || 0);
    });
  }, []);
  const getData = () => {
    let params = "id=" + id;
    let result = ManageOrders("", "get", "", params);
    result.then((result) => {
      setData({
        ...data,
        data: result.data?.results,
      });
      if (result.data.results[0].status) {
        setstatus(true);
      }
    });
  };

  return (
    <div>
      <div id="main-wrapper">
        <MainHeader />
        <Header name={"Order Details"} subHeading={"FDR" + id} />
        <NavBar />
        <Body
          data={data.data}
          orderid={id}
          Status={status}
          foodReadyAt={foodReadyAt}
          onFoodReadyChange={setFoodReadyAt}
          editCount={editCount}
        />
        <Footer />
      </div>
    </div>
  );
}

export default OrderID;
